import React, { useState, useRef, useEffect } from 'react';

import './DiscountProgramCarousel.scss';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

import DiscountProgramProduct from '../DiscountProgramProduct/DiscountProgramProduct.jsx';

const { LeftArrow, RightArrow } = icons;

let touchstartX = 0;
let touchendX = 0;

export default function DiscountProgramCarousel(props) {
  const list = props.list || [];

  const productList = useRef(null);
  const [currentPage, togglePage] = useState(1);

  const lastPage = list.length;

  useEffect(() => {
    if (productList.current)
      productList.current.ontouchmove = (e) => {
        // Check if it's not strictly vertical swipe
        // and then block vertical page scrolling
        if (Math.abs(touchstartX - e.changedTouches[0].screenX) > 5)
          e.preventDefault();
      };
  }, []);

  if (!list.length) return null;

  return (
    <section
      className={getString([
        {
          value: 'discountProgramCarousel',
          condition: true
        },
        {
          value: 'discountProgramCarousel_mobile',
          condition: props.isMobile
        }
      ])}
    >
      {props.titleLink ? (
        <a href={props.titleLink}>
          <h2>{props.title}</h2>
        </a>
      ) : (
        <h2>{props.title || 'Voordeel voor jou'}</h2>
      )}

      {currentPage !== 1 && (
        <div
          className="discountProgramCarousel_arrow
            discountProgramCarousel_arrow_left"
          onClick={() => move('backward')}
        >
          <LeftArrow />
        </div>
      )}

      <ul
        ref={productList}
        onTouchEnd={(e) => swipe(e)}
        onTouchStart={(e) => (touchstartX = e.changedTouches[0].screenX)}
      >
        {list.map((product, idx) => (
          <li key={idx}>
            <DiscountProgramProduct
              {...props}
              view="miniature"
              product={product}
              visibleByDefault={true}
              hideWishListIcon={true}
            />
          </li>
        ))}
      </ul>

      {currentPage !== lastPage && (
        <div
          className="discountProgramCarousel_arrow
            discountProgramCarousel_arrow_right"
          onClick={() => move('forward')}
        >
          <RightArrow />
        </div>
      )}
    </section>
  );

  function move(direction) {
    const isForward = direction === 'forward';

    const multiplier = document.body.offsetWidth <= 850 ? 0.8 : 1;

    const translateX = `${
      (isForward ? `-${currentPage}` : `-${currentPage - 2}`) * multiplier * 100
    }%`;

    productList.current.style.cssText = `
      transition-duration: .3s;
      transition-property: transform;
      transform: translateX(${translateX});
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }

  function swipe(e) {
    touchendX = e.changedTouches[0].screenX;

    const delta = touchendX - touchstartX;

    if (delta > 20) move('backward');
    else if (delta < -20 && currentPage !== lastPage) move('forward');
  }
}
